import React, { useCallback, useState } from "react";
import { CareCommentContent } from "../../../domain/care_comment/CareCommentContent";
import { CareCommentThreadId } from "../../../domain/care_comment/CareCommentThreadId";
import { CareCommentTitle } from "../../../domain/care_comment/CareCommentTitle";
import { useAppDispatch } from "../../../state/store";
import { registerCareCommentAction } from "../../../state/usecase/admin/care_comment/actions";
import { useCareRecipientIdFromPath } from "../../hooks/care_recipient/useCareRecipientIdFromPath";
import { useBoolean } from "../../hooks/common/useBoolean";
import { AddButton } from "../common/button/AddButton";
import { CancelCircleButton } from "../common/button/CancelCircleButton";
import { SaveButton } from "../common/button/SaveButton";
import { CareCommentEdit } from "./CareCommentEdit";
import { Navigate } from "react-router-dom";
import { Paths } from "../../../Paths";

export const AddCareComment = React.memo(function AddCareComment(props: AddCareCommentProps) {
    const dispatch = useAppDispatch();

    const careRecipientId = useCareRecipientIdFromPath();

    const { careCommentThreadId } = props;

    const [isEdit, editOn, editOff, ] = useBoolean();

    const [title, setTitle] = useState(""); 

    const [titleError, setTitleError] = useState("");

    const [content, setContent] = useState(""); 

    const [contentError, setContentError] = useState("");

    if (!careRecipientId) {
        return <Navigate to={Paths.root} />;
    }

    const resetState = useCallback(() => {
        setTitle("");
        setTitleError("");
        setContent("");
        setContentError("");
    }, []);


    const saveClick = useCallback(() => {
        // タイトルの長さチェック
        const titleError = CareCommentTitle.isInvalidSize(title) ? CareCommentTitle.messageInvalidSize("タイトル") : "";
        setTitleError(titleError);

        // 内容の長さチェック
        const contentError = CareCommentContent.isInvalidSize(content) ? CareCommentContent.messageInvalidSize("ケアコメント内容") : "";
        setContentError(contentError);

        if (titleError || contentError) return;

        dispatch(
            registerCareCommentAction({
                requestData: {
                    careRecipientId: careRecipientId,
                    threadId: careCommentThreadId,
                    title: CareCommentTitle.fromString(title),
                    content: CareCommentContent.fromString(content)
                }
            })
        );

        editOff();

        resetState();
    }, [title, content, dispatch, careRecipientId, careCommentThreadId, editOff, resetState]);

    const cancelClick = useCallback(() => {
        editOff();

        resetState();
    }, [editOff, resetState]);

    return (
        <div className={"add_care_comment"}>
            <div className={"buttons"}>
                {isEdit ? (
                    <div className={"admin_button_area"}>
                        <SaveButton onClick={saveClick} />
                        <CancelCircleButton className={"edit_cancel_button"} onClick={cancelClick} />
                    </div>
                ) : (
                    <AddButton label={"ケアコメント追加"} onClick={editOn} />
                )}
            </div>
            <CareCommentEdit
                title={title}
                handleTitle={setTitle}
                titleError={titleError}
                content={content}
                handleContent={setContent}
                contentError={contentError}
                show={isEdit}
            />
        </div>
    );
});

type AddCareCommentProps = {
    careCommentThreadId: CareCommentThreadId
}
